<template>
  <div class="user-info">
    <div class="user-info-avatar">
      <el-avatar class="avatar-border" shape="circle" :size="100" fit="fit" :src="userInfo.avatar"></el-avatar>
    </div>

    <div class="user-info-detail">
      <div class=""><span>{{ userInfo.nickname }}</span></div>
      <div class="">{{ userInfo.uid }} </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userInfoComponent',
  props: {
    userInfo: {
      type: Object,
      required: true
    },
    productInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style>
.el-divider--horizontal {
  margin: 10px 0;
  background-color: #494947 !important;
}
</style>

<style scoped>
.user-info {
  display: flex;
  position: relative;
  justify-content: space-between;
}

.user-info-avatar {
  margin: 10px;
  width: 150px;
}

.user-info-avatar img {
  height: auto;
  width: 150px;
  object-fit: cover;
  object-position: right;
}

.avatar-border {
  border: 1px solid #bba04b;
}

.user-info-detail {
  flex: 1;
  margin: 25px 0 0 25px;
}

.user-info-detail div {
  text-align: left;
  font-family: SourceHanSansCN-Regular;
  font-stretch: normal;
  margin-bottom: 10px;
  font-size: 20px;
}

.user-info-detail div span {
  font-weight: 700;
}

@media only screen and (max-width: 768px) {

  .user-info-avatar {
    margin: 5px 5px 0 5px;
  }

  .user-info-detail {
    margin: 10px 0 10px 5px;
  }

  .user-info-detail div {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/shop/components/userInfo.vue